import {CanActivate, ActivatedRouteSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {IInstanceModeleFormulaireWebServiceClient} from "app/common/resources/resources";

/**
 * Created by asi on 17/10/19.
 */

@Injectable()
export class EnsureGestionInstanceGuard implements CanActivate {

  constructor(private instanceModeleFormulaireWebServiceClient: IInstanceModeleFormulaireWebServiceClient) {

  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.instanceModeleFormulaireWebServiceClient.getAuthorizationAccessEdit(route.params['id']);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/formulaires/gestion-instance.guard.ts